// @ts-nocheck
export function abbreviateNumber(value, fixedDecimals) {
  if (value >= 1000) {
    const suffixes = ['', 'K', 'MM', 'b', 't'];
    const suffixNum = Math.floor(`${value}`.length / 3);
    let shortValue = '';
    for (let precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum !== 0 ? value / 1000 ** suffixNum : value).toFixed(fixedDecimals || 2));
      const dotLessShortValue = `${shortValue}`.replace(/[^a-zA-Z 0-9]+/g, '');
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    return (fixedDecimals ? shortValue.toFixed(fixedDecimals) : shortValue) + suffixes[suffixNum];
  }
  return fixedDecimals ? value.toFixed(fixedDecimals) : value;
}

export function validEmailAddress(email) {
  const emailRegEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegEx.test(String(email).toLowerCase());
}

export function deepKeyFind(item = {}, keyToFind) {
  let result;
  let p;
  if (item[keyToFind]) {
    return item[keyToFind];
  }
  for (p in item) {
    if (typeof item[p] === 'object') {
      result = deepKeyFind(item[p], keyToFind);
      if (result) {
        return result;
      }
    }
  }
  return result;
}
